import { IOnInit } from 'angular';

const DEFAULT_URL = location.origin ?? 'https://tradersyard.com';

class AffiliateSettingsComponent implements IOnInit {
    public affiliateId?: string;

    public baseUrl: string = DEFAULT_URL;
    public affiliateUrl: string = '';

    $onInit(): void {
        this._buildAffiliateUrl();
    }

    onBaseUrlChange() {
        this._buildAffiliateUrl();
    }

    private _buildAffiliateUrl() {
        let urlBuilder;

        try {
            urlBuilder = new URL(this.baseUrl);
        } catch (e) {
            urlBuilder = new URL(DEFAULT_URL);
        }

        urlBuilder.searchParams.set('affiliate', this.affiliateId ?? '');
        this.affiliateUrl = urlBuilder.toString();
    }
}

angular.module('tradersyard').component('tyAffiliateSettings', {
    // language=HTML
    template: `
        <div class="table">
            <h2>About Affiliate Program</h2>
            <div style="margin: 1em 0 2em" is-uib>
                <p>Our Affiliate Program lets you make money by brining in new users to TradersYard.</p>
                <p>You can manage your Affiliate account through <a href="https://shop.tradersyard.com/affiliates/"
                                                                    target="_blank">Tradersyard Affiliate Panel</a>.</p>
            </div>
            <h2>How to refer users?</h2>
            <div style="margin: 1em 0 2em" is-uib>
                <p>The easiest way to start is to use our URL generator below to get <strong>your unique Affiliate
                    URL</strong>.</p>
                <p>By sending users to your Affiliate URL, we will be able to relate them to your account. Any new users
                    that signup for TradersYard will be linked with your Affiliate Account.</p>
            </div>
            <h2>Generate Affiliate URL</h2>
            <div style="margin-top: 1em" is-uib>
                <div class="form-group">
                    <label>Your Affiliate ID</label>
                    <p class="form-control-static">{{ $ctrl.affiliateId }}</p>
                </div>
                <div class="form-group">
                    <label for="tyUrl">Paste TradersYard URL</label>
                    <input type="url" class="form-control" id="tyUrl"
                           placeholder="${DEFAULT_URL}"
                           ng-model="$ctrl.baseUrl"
                           ng-change="$ctrl.onBaseUrlChange()"
                           required>
                </div>
                <div class="form-group">
                    <div class="panel panel-primary">
                        <div class="panel-heading">
                            <label for="affiliateUrl" class="panel-title">Your Unique Affiliate URL</label>
                        </div>
                        <div class="panel-body">
                            <code ng-bind="$ctrl.affiliateUrl" style="user-select: all"></code>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    controller: AffiliateSettingsComponent,
    bindings: {
        affiliateId: '@',
    },
});

export {};
